
<div *ngIf="!autoMlService.isAutoMl" class="scad-read-tab">
  <div class="scad-zoom-in ">
    <div class="scad-zoom-in__wrapper d-flex align-items-center">
      <div class="d-flex align-items-center scad-zoom-in__icons">
        <div class="d-flex me-2">
          <img src="../../../../../assets/images/svg/box-white.svg" alt="" />
        </div>
        <div class="d-flex me-2">
          <img src="../../../../../assets/images/svg/star-white.svg" alt="" />
        </div>
        <div class="d-flex me-2">
          <img src="../../../../../assets/images/svg/full-screen.svg" alt="" />
        </div>
        <div class="d-flex me-2">
          <img src="../../../../../assets/images/svg/next-page.svg" alt="" />
        </div>
      </div>
      <div class="d-flex align-items-center scad-zoom-in__progress">
        <div class="d-flex align-items-center">
          <input
            type="range"
            id="vol"
            name="vol"
            min="0"
            max="100"
            [(ngModel)]="_fb.dragAreaZoom"
            (change)="_fb.getRangeChange()"
          />
          <span class="ms-1 white">{{ _fb.dragAreaZoom + "%" }}</span>
        </div>
      </div>
    </div>
  </div>

  <svg
    class="toggle"
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="21"
    viewBox="0 0 53 21"
    fill="none"
  >
    <rect
      x="53"
      width="21"
      height="53"
      rx="10.5"
      transform="rotate(90 53 0)"
      fill="#9DA2AE"
    />
    <path
      d="M23.1001 12.4429L26.2337 16.4095L29.3334 12.4429"
      stroke="white"
      stroke-width="1.61905"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.3335 8.39502L26.1999 4.42835L23.1002 8.39502"
      stroke="white"
      stroke-width="1.61905"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <div class="scad-read-tab__tab-item-area ">
    <div class="scad-title__semi-bold mb-4">Read</div>

    <div class="scad-read-tab__tab-item">
      <div
        class="scad-read-tab__tab"
        [class.active]="selectedTab === 'tab1'"
        (click)="selectTab('tab1')"
      >
        Preview
      </div>
      <div
        class="scad-read-tab__tab"
        [class.active]="selectedTab === 'tab2'"
        (click)="selectTab('tab2')"
      >
        Configuration
      </div>
      <div
        class="scad-read-tab__tab"
        [class.active]="selectedTab === 'tab3'"
        (click)="selectTab('tab3')"
      >
        Logs
      </div>
      <div
        class="scad-read-tab__tab"
        [class.active]="selectedTab === 'tab4'"
        (click)="selectTab('tab4')"
      >
        Set Up
      </div>
      <div
        class="scad-read-tab__tab"
        [class.active]="selectedTab === 'tab5'"
        (click)="selectTab('tab5')"
      >
        Details
      </div>
    </div>
  </div>

  <div class="scad-read-tab__tab-content ">
    <ng-container *ngIf="selectedTab === 'tab2'">
      <!-- Content for Tab 1 -->
      <div class="scad-read-tab__tab-content-body">
        <div class="scad-read-tab__tab-content-head">
          <div class="scad-read-tab__tab-content-sub-content">
            <div class="scad-title__sm-label">
              Completed on : <span> 12/09/2023 9:00 am</span>
            </div>
            <div class="scad-title__sm-label d-flex line3">
              Sync time :
              <span class="d-flex">
                290 ms
                <span class="d-flex mx-2"
                  ><img src="/assets/images/svg/tick-black.svg" alt=""
                /></span>
              </span>
            </div>
          </div>
          <button class="scad-btn scad-btn--primary">Test Connection</button>
        </div>

        <div class="scad-form">
          <div class="scad-input pt-4">
            <div class="scad-title__sm-label mb-3">Component name</div>
            <input
              type="text"
              class="scad-input-half"
              placeholder="Enter here"
            />
          </div>
          <div class="scad-input pt-4">
            <div class="scad-title__sm-label mb-3">
              Component description (optional)
            </div>
            <input
              type="text"
              class="scad-input-half"
              placeholder="Enter here"
            />
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedTab === 'tab1'">
      <app-preview-section></app-preview-section>
    </ng-container>
    <ng-container *ngIf="selectedTab === 'tab3'">
      <!-- Content for Tab 2 -->
      <div class="scad-tab-log pt-3">
        <div class="scad-tab-log__header">
          <div class="d-flex scad-tab-log__tabs">
            <div class="scad-tab-log__item active">Current</div>
            <div class="scad-tab-log__item">All</div>
          </div>

          <div>
            <div class="scad-table-filter">
              <button
                class="scad-table-filter__btn"
                [matMenuTriggerFor]="filter"
              >
                <span class="scad-table-filter__icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.3335 3.33331H16.6668V5.14331C16.6667 5.5853 16.4911 6.00916 16.1785 6.32165L12.5002 9.99998V15.8333L7.50016 17.5V10.4166L3.76683 6.30998C3.48804 6.00325 3.33354 5.60364 3.3335 5.18915V3.33331Z"
                      stroke="#1847DF"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span> Filter </span>
              </button>

              <mat-menu
                #filter="matMenu"
                class="scad-table__table-filter-dropdown"
              >
                <div class="scad-title__sm-label-sub2 pb-3 pt-3">
                  <span
                    >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="18"
                      viewBox="0 0 17 18"
                      fill="none"
                    >
                      <path
                        d="M0 0H16.6667V2.2625C16.6665 2.81499 16.447 3.34481 16.0562 3.73542L11.4583 8.33333V15.625L5.20833 17.7083V8.85417L0.541667 3.72083C0.193174 3.33742 5.53743e-05 2.83791 0 2.31979V0Z"
                        fill="#9DA2AE"
                      />
                      </svg>
                </span>
                  Filters
                </div>

                <div>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="scad-checkbox scad-checkbox__small-check pb-2">
                      <input type="checkbox" name="all" id="" />
                      <label class="filter-text" for="selectitem"
                        >Status
                      </label>
                    </div>

                    <div>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.66675 6.6665L9.93336 13.3332L15.1429 6.6665"
                          stroke="#364151"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>

                  <div class="ps-4">
                    <div class="scad-checkbox scad-checkbox__small-check">
                      <input type="checkbox" name="" id="aa" />
                      <label class="scad-title__sm-label-sub" for="aa">
                        Errors
                      </label>
                    </div>

                    <div class="scad-checkbox scad-checkbox__small-check">
                      <input type="checkbox" name="" id="" />
                      <label class="scad-title__sm-label-sub" for="dd">
                        Warning</label
                      >
                    </div>

                    <div class="scad-checkbox scad-checkbox__small-check">
                      <input type="checkbox" name="" id="" />
                      <label class="scad-title__sm-label-sub" for="33">
                        Success
                      </label>
                    </div>
                  </div>
                </div>
                <div class="line line--line2 mt-3 mb-3"></div>

                <div>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="scad-checkbox scad-checkbox__small-check pb-2">
                      <input type="checkbox" name="all" id="" />
                      <label class="filter-text" for="selectitem"
                        >Activity Type
                      </label>
                    </div>

                    <div>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.66675 6.6665L9.93336 13.3332L15.1429 6.6665"
                          stroke="#364151"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>

                  <div class="ps-4">
                    <div class="scad-checkbox scad-checkbox__small-check">
                      <input type="checkbox" name="" id="aa" />
                      <label class="scad-title__sm-label-sub" for="aa">
                        Test Connection
                      </label>
                    </div>

                    <div class="scad-checkbox scad-checkbox__small-check">
                      <input type="checkbox" name="" id="" />
                      <label class="scad-title__sm-label-sub" for="dd">
                        Run</label
                      >
                    </div>

                    <div class="scad-checkbox scad-checkbox__small-check">
                      <input type="checkbox" name="" id="" />
                      <label class="scad-title__sm-label-sub" for="33">
                        Pipeline validation
                      </label>
                    </div>
                  </div>
                </div>
              </mat-menu>
            </div>
          </div>
        </div>
        <div class="scad-tab-log__body">
          <div class="scad-tab-log__table">
            <div class="table-wrapper">
              <table>
                <tbody>
                  <tr>
                    <th *ngFor="let item of tableKeys">{{ item }}</th>
                  </tr>
                  <tr *ngFor="let item of testData; let i = index">
                    <td *ngFor="let key of tableKeys">
                      <div class="data-cell">
                        <svg
                          *ngIf="item[key] === 'Success'"
                          xmlns="http://www.w3.org/2000/svg"
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                        >
                          <path
                            d="M11.1752 19.2837C15.6534 19.2837 19.2837 15.6534 19.2837 11.1752C19.2837 6.69696 15.6534 3.06665 11.1752 3.06665C6.69696 3.06665 3.06665 6.69696 3.06665 11.1752C3.06665 15.6534 6.69696 19.2837 11.1752 19.2837Z"
                            fill="#659B5C"
                          />
                          <path
                            d="M6.89331 11.141L9.96818 14.2159L15.4574 8.13452"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <svg
                          *ngIf="item[key] === 'Error'"
                          xmlns="http://www.w3.org/2000/svg"
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                        >
                          <path
                            d="M20.125 11.5C20.125 6.73828 16.2617 2.875 11.5 2.875C6.73828 2.875 2.875 6.73828 2.875 11.5C2.875 16.2617 6.73828 20.125 11.5 20.125C16.2617 20.125 20.125 16.2617 20.125 11.5Z"
                            fill="#E65E6E"
                          />
                          <path
                            d="M11.2422 7.4593L11.5001 12.9375L11.7575 7.4593C11.7591 7.42428 11.7535 7.3893 11.7411 7.35651C11.7287 7.32371 11.7098 7.29378 11.6854 7.26856C11.6611 7.24333 11.6318 7.22333 11.5995 7.20979C11.5672 7.19624 11.5324 7.18943 11.4974 7.18977V7.18977C11.4627 7.1901 11.4285 7.1974 11.3968 7.21124C11.365 7.22509 11.3364 7.24519 11.3125 7.27034C11.2887 7.2955 11.2702 7.3252 11.2581 7.35766C11.2461 7.39013 11.2406 7.4247 11.2422 7.4593V7.4593Z"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11.5 16.5272C11.3223 16.5272 11.1486 16.4745 11.0009 16.3758C10.8531 16.2771 10.738 16.1368 10.67 15.9726C10.602 15.8084 10.5842 15.6278 10.6188 15.4535C10.6535 15.2792 10.7391 15.1191 10.8647 14.9935C10.9904 14.8678 11.1504 14.7823 11.3247 14.7476C11.499 14.7129 11.6796 14.7307 11.8438 14.7987C12.008 14.8667 12.1483 14.9819 12.247 15.1296C12.3457 15.2774 12.3984 15.4511 12.3984 15.6288C12.3984 15.8671 12.3038 16.0956 12.1353 16.2641C11.9668 16.4326 11.7383 16.5272 11.5 16.5272Z"
                            fill="white"
                          />
                        </svg>
                        {{ item[key] }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination">
              <div class="row-count">
                <p>Row per page</p>
                <ng-select
                  [items]="pageArr"
                  [searchable]="false"
                  [clearable]="false"
                  [(ngModel)]="selectedPage"
                ></ng-select>
                <p>{{ "of " + _fb.previewData.length + " rows" }}</p>
              </div>
              <div class="row-pagination">
                <svg
                  (click)="decriement()"
                  class="left"
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <circle
                    cx="16"
                    cy="16"
                    r="16"
                    transform="matrix(-1 0 0 1 32 0)"
                    fill="#1847DF"
                  />
                  <path
                    d="M13 12.5L18 16.45L13 20.3571"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="number">{{ page }}</div>
                <p>{{ "out of " + testData.length }}</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  (click)="incriement()"
                >
                  <circle
                    cx="16"
                    cy="16"
                    r="16"
                    transform="matrix(-1 0 0 1 32 0)"
                    fill="#1847DF"
                  />
                  <path
                    d="M13 12.5L18 16.45L13 20.3571"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedTab === 'tab4'">
      <div>
        <div class="scad-title__semi-bold mb-4">Setup</div>
        <div class="d-flex scad-tab-log__tabs">
          <div class="scad-tab-log__item active">Steps</div>
          <div class="scad-tab-log__item">Documentation</div>
          <div class="scad-tab-log__item">Troubleshooting</div>
        </div>

        <div class="scad-setup mt-3">
          <div class="scad-setup__body">
            <div class="me-3">
              <img
                src="../../../../../assets/images/svg/tick-setup.svg"
                width="30px"
                alt=""
              />
            </div>
            <div class="scad-setup__item">
              <div class="scad-setup__text">
                Choose whether to import data from a Connector or a Dataset.
              </div>
              <div class="d-flex align-items-center scad-setup__item-left">
                <div>Selected</div>
                <div class="scad-setup__btn">Dataset</div>
              </div>
            </div>
          </div>
          <div class="scad-setup__body">
            <div class="me-3">
              <img
                src="../../../../../assets/images/svg/tick-setup.svg"
                width="30px"
                alt=""
              />
            </div>
            <div class="scad-setup__item">
              <div class="scad-setup__text">
                Choose whether to import data from a Connector or a Dataset.
              </div>
              <div class="d-flex align-items-center scad-setup__item-left">
                <div>Selected</div>
                <div class="scad-setup__btn">Dataset</div>
              </div>
            </div>
          </div>

          <div class="scad-setup__body">
            <div class="me-3">
              <img
                src="../../../../../assets/images/svg/tick-setup.svg"
                width="30px"
                alt=""
              />
            </div>

            <div class="scad-setup__item-upload">
              <div class="scad-setup__item">
                <div class="scad-setup__text">Select and Upload file.</div>
                <div></div>
              </div>
              <div class="d-flex align-items-center scad-setup__item-upload2">
                <div>Uploaded</div>
                <div class="scad-setup__btn scad-setup__btn2">
                  <span class="d-flex"
                    ><img
                      class="me-3"
                      src="../../../../../assets/images/svg/excel-icon.svg"
                      alt=""
                  /></span>
                  Samplefilename.xlsx
                  <span class="d-flex ps-5"
                    ><img
                      src="../../../../../assets/images/svg/info.svg"
                      alt=""
                  /></span>
                </div>
              </div>
              <div class="line2"></div>

              <div
                class="d-flex align-items-center scad-setup__btn-setup-wrapper"
              >
                <div class="scad-setup__btn-setup">
                  <div class="d-flex align-items-center">
                    <div class="d-flex">
                      <img
                        class="me-3"
                        src="../../../../../assets/images/svg/tick-one.svg"
                        alt=""
                      />
                    </div>
                    <div class="">
                      <div class="scad-setup__text">Select Worksheet</div>
                      <div class="scad-setup__text2">
                        You have only 1 worksheet.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="scad-setup__btn-setup">
                  <div class="d-flex align-items-center">
                    <div class="d-flex">
                      <img
                        class="me-3"
                        src="../../../../../assets/images/svg/tick-two.svg"
                        alt=""
                      />
                    </div>

                    <div class="">
                      <div class="scad-setup__text">Choose Header Row</div>
                      <div class="scad-setup__text2">
                        Default selection: First Row
                      </div>
                    </div>
                  </div>
                </div>
                <div class="scad-setup__btn-setup blue">
                  <div class="d-flex align-items-center">
                    <div class="d-flex">
                      <img
                        class="me-3"
                        src="../../../../../assets/images/svg/arrow-right.svg"
                        alt=""
                      />
                    </div>

                    <div class="">
                      <div class="scad-setup__text">Select Worksheet</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedTab === 'tab5'">
      <div class="scd-details__wrapper">
        <div class="scd-details__form-outer">
          <div class="scad-form">
            <div class="scad-input">
              <div class="scad-title__sm-label mb-3">Component name</div>
              <input
                type="text"
                class="scad-input-half"
                placeholder="Enter here"
              />
            </div>
            <div class="scd-details__file-used">
              <div class="scd-details__file-txt">
                File used
              </div>
              <div class="scd-details__file-name">
                Filename <img src="../../../../../assets/images/svg/settings-icon.svg" alt="">
              </div>
            </div>
            <div class="scad-input pt-4">
              <div class="scad-title__sm-label mb-3">
                Component description (optional)
              </div>
              <textarea
                name=""
                class="sh-input-text"
                id=""
                cols="100%"
                rows="4"
                placeholder="Description Here.."
              ></textarea>
            </div>
          </div>
        </div>

        <div class="scd-details__user-outer">
          <div class="scd-details__user-tile">
            <div class="scd-details__light-txt">Updated By</div>
            <div class="scd-details__bold-txt">
              Khalid Al Hashemi (Auto-save)
            </div>
          </div>
          <div class="scd-details__user-tile">
            <div class="scd-details__light-txt">Updated on</div>
            <div class="scd-details__bold-txt">
              19/03/2023 9:18 am

            </div>
          </div>
          <div class="scd-details__user-tile">
            <div class="scd-details__light-txt">Added by</div>
            <div class="scd-details__bold-txt">
              Mariam Al Sharqi

            </div>
          </div>
          <div class="scd-details__user-tile">
            <div class="scd-details__light-txt">Added on</div>
            <div class="scd-details__bold-txt">
              07/03/2023 1:20 am
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

</div>
<div *ngIf="autoMlService.isAutoMl">
  <app-auto-ml-preview></app-auto-ml-preview>
</div>